import React from "react";

import styles from "./SideMenu.module.css"
import classnames from "classnames";
import {MenuItem, selectedMenuItemSelector} from "../platformSlice";
import {useAppSelector} from "../../../../app/hooks";
import {Link} from "react-router-dom";

interface HeaderProps {
}

export const SideMenu: React.FC<HeaderProps> = () => {

    const selectedMenuItem = useAppSelector(selectedMenuItemSelector);

    const isSelected = (sideMenuItem: MenuItem) => {
        return selectedMenuItem === sideMenuItem;
    }

    const getMenuItemPath = (menuItem: MenuItem) => {
        switch (menuItem) {
            case MenuItem.LOCATIONS:
                return "/locations"
            case MenuItem.FRANCHISES:
                return "/franchises"
            case MenuItem.ASSISTANTS:
                return "/assistants"
            case MenuItem.TRANSCRIPTS:
                return "/transcripts"
            case MenuItem.ANALYTICS:
                return "/analytics"
            case MenuItem.KNOWLEDGE_SETTINGS:
                return "/knowledge-settings"
            case MenuItem.FEEDBACK:
                return "/feedbacks"
            case MenuItem.BULK_UPDATE:
                return "/bulk-update"
        }
    }

    return <div className={styles.wrapper}>
        <div className={styles.logoWrapper}>
            <img src={"/logo.svg"} alt="logo"/>
        </div>
        <Link
            to={getMenuItemPath(MenuItem.ANALYTICS)}
            className={classnames(styles.element, isSelected(MenuItem.ANALYTICS) && styles.selectedElement)}>
            <img src={"/analyticsMenuItemIcon.svg"} alt={"analytics menu icon"}/>
            <span className={styles.title}>Analytics</span>
        </Link>
        <Link
            to={getMenuItemPath(MenuItem.FEEDBACK)}
            className={classnames(styles.element, isSelected(MenuItem.FEEDBACK) && styles.selectedElement)}>
            <img src={"/feedbackMenuItemIcon.svg"} alt={"feedback menu icon"}/>
            <span className={styles.title}>Feedbacks</span>
        </Link>
        <Link
            to={getMenuItemPath(MenuItem.KNOWLEDGE_SETTINGS)}
            className={classnames(styles.element, isSelected(MenuItem.KNOWLEDGE_SETTINGS) && styles.selectedElement)}>
            <img src={"/knowledgeMenuItemIcon.svg"} alt={"knowledge menu icon"}/>
            <span className={styles.title}>Knowledge</span>
        </Link>
        <Link
            to={getMenuItemPath(MenuItem.LOCATIONS)}
            className={classnames(styles.element, isSelected(MenuItem.LOCATIONS) && styles.selectedElement)}>
            <img src={"/locationMenuItemIcon.svg"} alt={"location menu icon"}/>
            <span className={styles.title}>Locations</span>
        </Link>
        <Link
            to={getMenuItemPath(MenuItem.FRANCHISES)}
            className={classnames(styles.element, isSelected(MenuItem.FRANCHISES) && styles.selectedElement)}>
            <img src={"/franchisesMenuIcon.svg"} alt={"franchise menu icon"}/>
            <span className={styles.title}>Franchises</span>
        </Link>
        <Link
            to={getMenuItemPath(MenuItem.ASSISTANTS)}
            className={classnames(styles.element, isSelected(MenuItem.ASSISTANTS) && styles.selectedElement)}>
            <img src={"/assistantMenuItemIcon.svg"} alt={"assistant menu icon"}/>
            <span className={styles.title}>Assistants</span>
        </Link>
        <Link
            to={getMenuItemPath(MenuItem.TRANSCRIPTS)}
            className={classnames(styles.element, isSelected(MenuItem.TRANSCRIPTS) && styles.selectedElement)}>
            <img src={"/transcriptMenuItemIcon.svg"} alt={"transcript menu icon"}/>
            <span className={styles.title}>Transcripts</span>
        </Link>
        <Link
            to={getMenuItemPath(MenuItem.BULK_UPDATE)}
            className={classnames(styles.element, isSelected(MenuItem.BULK_UPDATE) && styles.selectedElement)}>
            <img src={"/bulkUpdateMenuItemIcon.svg"} alt={"bulk update menu icon"}/>
            <span className={styles.title}>Bulk update</span>
        </Link>
    </div>
}
